import highlightText from "utils/highlightText";

export const renderDeletionMessage = (voucherDescription: string) =>
  highlightText({
    baseStyle: { whiteSpace: "pre-wrap" },
    highlightStyle: { fontWeight: "bold", fontStyle: "italic" },
  })`Are you sure you want to delete vouchers ${voucherDescription} ?\nThis can not be undone.`;
